<template>
  <div class="videoDate">
    <div>
      <i class="iconfont icon_shipin_bofangshu"></i>
      <span>194万</span>
    </div>
    <div>
      <i class="iconfont icon_shipin_danmushu"></i>
      <span>183</span>
    </div>
    <div>
      <span>2024年4月6日 09:10</span>
    </div>

  </div>
</template>

<script>
export default {
  name: "datePage"
}
</script>

<style scoped lang="scss">
.videoDate{
  display: flex;
  align-items: center;
  margin-left: 3vw;
  div{
    margin-right: 3vw;
    color: #a0a0a0;
    font-size: 3.2vmin;
    font-style: normal;
    .iconfont{
      font-size: 3.4vmin !important;
    }
  }
}
</style>
